<template>
    <div
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div
            class="
                flex
                items-end
                justify-center
                min-h-screen
                pt-4
                px-4
                pb-20
                text-center
                sm:block sm:p-0
            "
        >
            <div
                class="
                    fixed
                    inset-0
                    bg-gray-500 bg-opacity-75
                    transition-opacity
                "
                aria-hidden="true"
            ></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
                >&#8203;</span
            >

            <div
                class="
                    inline-block
                    align-bottom
                    bg-white
                    px-4
                    pt-5
                    pb-4
                    text-left
                    overflow-hidden
                    shadow-xl
                    transform
                    transition-all
                    sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6
                "
            >
                <div>
                    <div class="mb-5">
                        <div class="text-xl font-bold">
                            Add & manage categories
                        </div>

                        <div class="mt-5">
                            <div class="font-bold mb-2">Add new category</div>
                            <div class="grid lg:grid-cols-2 gap-4">
                                <div
                                    v-for="(newCat, index) in newCategories"
                                    :key="index"
                                >
                                    <div class="flex">
                                        <label
                                            :for="'category_name-' + index"
                                            class="sr-only"
                                            >Category Name</label
                                        >
                                        <input
                                            type="text"
                                            :id="'category_name-' + index"
                                            name="category_name[]"
                                            v-model="newCat.name"
                                            class="
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                block
                                                w-full
                                                sm:text-sm
                                                border-0 border-b
                                                p-0
                                            "
                                            placeholder="Enter desired category name"
                                        />
                                        <button
                                            class="px-3"
                                            @click="removeNewCategory(index)"
                                        >
                                            <img
                                                class="w-5"
                                                src="../../../img/trash-icon.svg"
                                                alt="delete"
                                            />
                                        </button>
                                    </div>
                                    <div
                                        v-if="errors[`create.${index}.name`]"
                                        class="text-sm text-red-400"
                                    >
                                        {{ errors[`create.${index}.name`][0] }}
                                    </div>
                                </div>
                            </div>
                            <button
                                @click="addNewCategory"
                                class="
                                    mt-2
                                    underline
                                    focus:outline-none
                                    focus:ring-1
                                    focus:ring-indigo-500
                                    focus:border-indigo-500
                                "
                            >
                                + Add category
                            </button>
                        </div>

                        <div class="mt-5">
                            <div class="font-bold mb-2">
                                Manage Existing catgories
                            </div>

                            <draggable
                                v-model="existingCategories"
                                group="categoriesgroup"
                                @end="onDragEnd()"
                                item-key="id"
                                direction="horizontal"
                            >
                                <template #item="{ element, index }">
                                    <div class="py-2">
                                        <div class="flex">
                                            <div class="px-2 mr-2 cursor-pointer" >
                                                <img
                                                    class="w-5"
                                                    src="../../../img/draggable_icon.svg"
                                                    alt="delete"
                                                />
                                            </div>
                                            <label
                                                :for="'category_name-' + index"
                                                class="sr-only"
                                                >Category Name</label
                                            >
                                            <input
                                                type="text"
                                                v-model="element.name"
                                                name="category_names_existing[]['name']"
                                                :id="'category_name-' + index"
                                                class="
                                                    focus:ring-indigo-500
                                                    focus:border-indigo-500
                                                    block
                                                    w-full
                                                    sm:text-sm
                                                    border-0 border-b
                                                    p-0
                                                "
                                                placeholder="Enter desired category name"
                                            />
                                            <input
                                                type="text"
                                                v-model="element.id"
                                                name="category_names_existing[]['id']"
                                                class="hidden"
                                            />
                                            <button
                                                class="px-3"
                                                @click="
                                                    removeExisitngCategory(
                                                        index,
                                                        element.id
                                                    )
                                                "
                                            >
                                                <img
                                                    class="w-5"
                                                    src="../../../img/trash-icon.svg"
                                                    alt="delete"
                                                />
                                            </button>
                                        </div>
                                        <div
                                            v-if="
                                                errors[`existing.${index}.name`]
                                            "
                                            class="text-sm text-red-400"
                                        >
                                            {{
                                                errors[
                                                    `existing.${index}.name`
                                                ][0]
                                            }}
                                        </div>
                                    </div>
                                </template>
                            </draggable>
                        </div>
                    </div>
                </div>

                <div class="text-center text-red-400" v-if="generalError">
                    {{ generalError }}
                </div>

                <div class="mt-5 sm:mt-6 flex space-x-4">
                    <button
                        type="button"
                        class="
                            inline-flex
                            justify-center
                            w-full
                            bg-gray-500
                            hover:bg-gray-700
                            text-white
                            font-bold
                            py-2
                            px-4
                        "
                        @click="$emit('updateVisible', false)"
                    >
                        Cancel
                    </button>

                    <button
                        @click.prevent="submit"
                        type="button"
                        class="
                            inline-flex
                            justify-center
                            w-full
                            bg-blue-500
                            hover:bg-blue-700
                            text-white
                            font-bold
                            py-2
                            px-4
                        "
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    props: [],
    components: {
        draggable,
    },
    emits: ["updateVisible"],
    data() {
        return {
            existingCategories: [],
            newCategories: [
                {
                    name: "",
                },
            ],
            toDeleteCategories: [],
            errors: {},
            generalError: "",
        };
    },
    methods: {
        onDragEnd() {
            let sortedCategoriesId = this.existingCategories.map(
                (category) => category.id
            );

            axios
                .post(`/api/categories-sort`, sortedCategoriesId)
                .then((response) => {
                    console.log("response");
                });
        },
        addNewCategory() {
            this.newCategories.push({
                name: "",
            });
        },
        removeNewCategory(index) {
            this.newCategories.splice(index, 1);
        },
        removeExisitngCategory(index, categoryId) {
            this.generalError = "";

            axios
                .post(`/api/categories/can-remove`, {
                    id: categoryId,
                })
                .then((response) => {
                    if (!response.data.can_delete) {
                        this.generalError =
                            "Category cannot be deleted as there are assets attached to it.";
                        return;
                    }

                    this.existingCategories.splice(index, 1);
                    this.toDeleteCategories.push(categoryId);
                });
        },
        submit() {
            this.errors = {};

            axios
                .post(`/api/categories/batches`, {
                    existing: this.existingCategories,
                    create: this.newCategories,
                    delete: this.toDeleteCategories,
                })
                .then((response) => {
                    this.$emit("updateVisible", false, "Updated!");
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                    } else if (error.request) {
                        // console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        // console.log("Error", error.message);
                    }
                });
        },
    },
    mounted() {
        axios.get(`/api/categories`).then((response) => {
            this.existingCategories = response.data.data;
        });
    },
};
</script>
